import { Dropdown } from './../../shared/models/dropdown.model';
import { DROPDOWN_REPORTING_CYCLE_YEAR } from './../../shared/constants/constant';
import { ReportingCycleDetails } from './../../shared/models/reportingcycle.model';
import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, combineLatest, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ManageReportingService } from 'src/app/modules/manage-reporting-cycle/services/manage-reporting.service';
import { CoreService } from './core.service';

@Injectable({
  providedIn: 'root',
})
export class ReportingYearsService implements Resolve<any> {
  baselineReportingCycleOptions: Dropdown[];
  selectedYear: string;
  selectedYearSubject = new Subject();

  constructor(
    private coreService: CoreService,
    private manageReporting: ManageReportingService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> | any {
    return combineLatest([
      this.manageReporting.getCurrentReportingCycleData(),
    ]).pipe(
      map((allResponses) => {
        const response = allResponses[0];

        const currentReportingCycle = response.filter(
          (reports: ReportingCycleDetails) => reports.isActive === '1',
        );
        const previousReportingCycle = response.filter(
          (reports: ReportingCycleDetails) => reports.isActive === '0',
        );

        const years = [];
        const baseReportingCycleYears = [];

        previousReportingCycle.forEach((x: ReportingCycleDetails) => {
          years.push(x.reportingCycleCode);
        });
        currentReportingCycle.forEach((x: ReportingCycleDetails) => {
          years.push(x.reportingCycleCode);
        });

        for (const year of years) {
          const value = this.coreService.getDropdownValueByID(year);
          baseReportingCycleYears.push(value);
        }

        const baselineReportingCycleOptions = [];
        const reportingCycleOptions = this.coreService.getDropdownValuesByID(
          DROPDOWN_REPORTING_CYCLE_YEAR,
        );

        reportingCycleOptions.forEach((x: Dropdown) => {
          if (baseReportingCycleYears.indexOf(x.dropdownDesc) > -1) {
            baselineReportingCycleOptions.push(x);
          }
        });

        this.baselineReportingCycleOptions = baselineReportingCycleOptions.sort(
          (a, b) => (b.dropdownOrder ?? 0) - (a.dropdownOrder ?? 0),
        );

        return baselineReportingCycleOptions;
      }),
    );
  }
}
